export const throttle = (fn, wait) => {
  let time = Date.now();

  return event => {
    // dismiss every wheel event with deltaY less than 4
    try {
      if (Math.abs(event.deltaY) < 2) {
        return;
      }

      if (time + wait - Date.now() < 0) {
        fn(event);
        time = Date.now();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(`Error in throttle. ${err}`);
    }
  };
};
